export default __webpack_public_path__ + "static/media/faq.4a4d6f2d.svg";